import { Box, styled, Typography } from '@mui/material';

export const ProfitTargetContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexGrow: 1,
  minHeight: 100,
  width: '100%',
}));

export const ProfitTargetTitle = styled(Typography)(() => ({
  whiteSpace: 'nowrap',
}));

export const GaugeContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'gaugeWidth' && prop !== 'gaugeHeight',
})<{
  gaugeWidth: number;
  gaugeHeight: number;
}>(({ gaugeWidth, gaugeHeight }) => ({
  position: 'relative',
  width: gaugeWidth,
  height: gaugeHeight,
  overflow: 'hidden',
  '& svg rect[width="14.6667"][height="47.4577"]': {
    display: 'none',
  },
  '& svg rect[width="4"][height="35.0775"]': {
    display: 'none',
  },
}));

export const GaugeNeedle = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'angle',
})<{ angle: number }>(({ theme, angle }) => ({
  position: 'absolute',
  left: '50%',
  bottom: theme.typography.pxToRem(30),
  width: theme.typography.pxToRem(5),
  height: theme.typography.pxToRem(50),
  backgroundColor: theme.palette.text.primary,
  borderRadius: theme.spacing(1),
  boxShadow: `0 0 0 ${theme.spacing(1.5)} ${theme.palette.background.paper}`,
  transformOrigin: 'bottom center',
  transform: `translateX(-50%) rotate(${angle}deg)`,
  transition: 'transform 300ms ease',
}));

export const GaugeCenter = styled(Box)(({ theme }) => ({
  position: 'absolute',
  left: '50%',
  bottom: 30,
  width: 8,
  height: 8,
  backgroundColor: theme.palette.background.paper,
  border: `2px solid ${theme.palette.text.primary}`,
  borderRadius: '50%',
  transform: 'translate(-50%, 50%)',
}));

export const GaugeLabelsContainer = styled(Box)(() => ({
  position: 'absolute',
  left: 20,
  right: 20,
  bottom: -5,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingLeft: 8,
  paddingRight: 8,
  paddingBottom: 4,
  pointerEvents: 'none',
}));
